import {
  faComment,
  faCommentDots,
  faBookmark as farBookmark,
  faHeart as farHeart,
} from "@fortawesome/free-regular-svg-icons";
import {
  faEllipsisH,
  faSpinner,
  faBookmark as fasBookmark,
  faHeart as fasHeart,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Spinner } from "react-bootstrap";
import images from "../../assets/images";
import "../../screens/community/style.css";

const PostsTab = ({
  posts,
  isLoading,
  isRefetching,
  user,
  navigate,
  loadingActions,
  commentInputs,
  handleCommentChange,
  handlePostComment,
  handleToggleAction,
  isLiked,
  isSaved,
  handleEditPost,
  handleDeletePost,
  handleReportPost,
  handleCopyLink,
  isAdminOrModerator,
  t,
}) => {
  if (isLoading)
    return (
      <p className="justify-content-center text-center">
        <Spinner />
      </p>
    );

  if (!isLoading && !isRefetching && posts?.length === 0) {
    return (
      <p className="justify-content-center text-center text-muted">
        {t("noPostFound")}
      </p>
    );
  }

  return (
    <>
      {posts?.map((post) => (
        <div
          key={post._id}
          className="card community-post shadow-sm mb-3 p-2"
          style={{ backgroundColor: "#161617" }}
        >
          <div className="d-flex">
            <div
              className="m-2 text-center mt-2"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/community/${post._id}`);
              }}
            >
              <img
                src={
                  post?.user?.picture
                    ? post.user.picture.startsWith("https")
                      ? post.user.picture
                      : post.user.picture.startsWith("images/")
                        ? `${process.env.REACT_APP_S3_BASE_URL}${post.user.picture}`
                        : images.profile.placeholder
                    : images.profile.placeholder
                }
                alt="avatar"
                className="rounded-circle"
                width="40"
                height="40"
              />
            </div>
            <div className="flex-grow-1">
              <div className="card-body pb-2">
                <div className="d-flex align-items-center gap-2 justify-content-between">
                  <div
                    className="d-flex align-items-center gap-2"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/community/${post._id}`);
                    }}
                  >
                    <p
                      className="mb-0 fw-semibold"
                      style={{ fontSize: "0.95rem" }}
                    >
                      {post?.user?._id === user?._id
                        ? `${post?.user?.first_name || ""} ${
                            post?.user?.last_name || ""
                          } (You)`
                        : `${post?.user?.first_name || ""} ${
                            post?.user?.last_name || ""
                          }` || "Unknown"}
                    </p>
                    <p
                      className="mb-0"
                      style={{ color: "#6c757d", fontSize: "0.75rem" }}
                    >
                      {post?.createdAt
                        ? new Intl.DateTimeFormat("en-US", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                          }).format(new Date(post.createdAt))
                        : ""}
                    </p>
                  </div>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      id={`dropdown-${post._id}`}
                      className="p-0 dots-toggle"
                      style={{
                        color: "#6c757d",
                        textDecoration: "none",
                      }}
                    >
                      <FontAwesomeIcon icon={faEllipsisH} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/community/${post._id}`);
                        }}
                      >
                        {t("viewPost")}
                      </Dropdown.Item>
                      {post?.user?._id === user?._id && (
                        <Dropdown.Item
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditPost(post._id);
                          }}
                        >
                          {t("editPost")}
                        </Dropdown.Item>
                      )}
                      {(post?.user?._id === user?._id ||
                        isAdminOrModerator) && (
                        <Dropdown.Item
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeletePost(post._id);
                          }}
                          disabled={loadingActions[`${post._id}-delete`]}
                        >
                          {loadingActions[`${post._id}-delete`] ? (
                            <>
                              <FontAwesomeIcon
                                icon={faSpinner}
                                spin
                                className="me-2"
                              />
                              {t("deleting")}
                            </>
                          ) : (
                            t("deletePost")
                          )}
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item
                        onClick={(e) => {
                          e.stopPropagation();
                          handleReportPost(post._id);
                        }}
                      >
                        {t("reportPost")}
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCopyLink(post._id);
                        }}
                      >
                        {t("copyLink")}
                      </Dropdown.Item>
                      {isSaved(post._id) && (
                        <Dropdown.Item
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToggleAction(post._id, "save");
                          }}
                          disabled={loadingActions[`${post._id}-save`]}
                        >
                          {loadingActions[`${post._id}-save`] ? (
                            <>
                              <FontAwesomeIcon
                                icon={faSpinner}
                                spin
                                className="me-2"
                              />
                              {t("unSaving")}
                            </>
                          ) : (
                            t("unsavePost")
                          )}
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <div className="px-3 pb-2 text-start">
                <p
                  className="mb-1"
                  style={{
                    fontSize: "0.9rem",
                    lineHeight: "1.3",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {post?.content || ""}
                </p>
              </div>
              {post?.imgorgif && (
                <img
                  src={
                    post.imgorgif?.startsWith("https")
                      ? post.imgorgif
                      : post.imgorgif?.startsWith("images") ||
                          post.imgorgif?.startsWith("videos")
                        ? `${process.env.REACT_APP_S3_BASE_URL}${post.imgorgif}`
                        : images.profile.placeholder
                  }
                  alt="post media"
                  className="post-media"
                />
              )}
              <div className="d-flex justify-content-between py-2">
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-link text-light"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggleAction(post._id, "like");
                    }}
                    disabled={loadingActions[`${post._id}-like`]}
                  >
                    {loadingActions[`${post._id}-like`] ? (
                      <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                    ) : (
                      <FontAwesomeIcon
                        icon={isLiked(post._id) ? fasHeart : farHeart}
                        className="me-1 purple-text"
                      />
                    )}
                    <span style={{ fontSize: "0.85rem" }}>
                      {post?.like || 0}
                    </span>
                  </button>
                  <button
                    className="btn btn-link text-light"
                    style={{ textDecoration: "none" }}
                  >
                    <FontAwesomeIcon
                      icon={faComment}
                      className="me-1 purple-text"
                    />
                    <strong>{post?.comments?.length || 0}</strong>
                  </button>
                </div>
                <button
                  className="btn btn-link text-light"
                  style={{ textDecoration: "none" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleToggleAction(post._id, "save");
                  }}
                  disabled={loadingActions[`${post._id}-save`]}
                >
                  {loadingActions[`${post._id}-save`] ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon
                      icon={isSaved(post._id) ? fasBookmark : farBookmark}
                      className="me-2 purple-text"
                    />
                  )}
                </button>
              </div>
              <div className="comments-section px-3 pb-3">
                <div className="d-flex gap-2 align-items-center mt-2">
                  <input
                    type="text"
                    className="form-control comment-input"
                    style={{ fontSize: "0.85rem", padding: "6px 10px" }}
                    placeholder="Write a comment..."
                    value={commentInputs[post._id] || ""}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) =>
                      handleCommentChange(post._id, e.target.value)
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handlePostComment(post._id);
                      }
                    }}
                  />
                  <button
                    className="comment-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePostComment(post._id);
                    }}
                    disabled={loadingActions[post._id] || isRefetching}
                  >
                    {loadingActions[post._id] || isRefetching ? (
                      <FontAwesomeIcon icon={faSpinner} spin />
                    ) : (
                      <FontAwesomeIcon
                        icon={faCommentDots}
                        color="var(--primaryColor)"
                        size="sm"
                        className="comment-icon"
                      />
                    )}
                  </button>
                </div>
                {post.comments &&
                  post.comments.length > 0 &&
                  post.comments.map((comment) => (
                    <div
                      key={comment._id}
                      className="d-flex mb-3 comment-item mt-4"
                    >
                      <img
                        src={
                          comment?.user?.picture
                            ? comment.user.picture.startsWith("https")
                              ? comment.user.picture
                              : comment.user.picture.startsWith("images/")
                                ? `${process.env.REACT_APP_S3_BASE_URL}${comment.user.picture}`
                                : images.profile.placeholder
                            : images.profile.placeholder
                        }
                        alt="comment avatar"
                        className="rounded-circle me-3"
                        width="30"
                        height="30"
                      />
                      <div className="flex-grow-1 text-start">
                        <p
                          style={{ fontSize: "0.8rem" }}
                          className="mb-0 fw-semibold text-muted"
                        >
                          {comment?.user?._id === user?._id
                            ? `${comment?.user?.first_name || ""} ${
                                comment?.user?.last_name || ""
                              } (You)`
                            : `${comment?.user?.first_name || ""} ${
                                comment?.user?.last_name || ""
                              }` || "Unknown"}
                        </p>
                        <p className="mb-0 text-start">{comment.comment}</p>
                        <p className="mb-0 p-sm" style={{ color: "#6c757d" }}>
                          {comment?.createdAt
                            ? new Intl.DateTimeFormat("en-US", {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              }).format(new Date(comment.createdAt))
                            : ""}
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default PostsTab;
